  <nav class="navbar navbar-expand-lg navbar-light bg-light justify-content-center">
    <ul class="navbar-nav d-flex flex-row align-items-center  justify-content-center"> <!-- Add align-items-center class -->

      <li class="nav-item " routerLink="/mobile/home" pRipple>
        <a class="nav-link" [ngClass]="{ 'active': activeTab === 'home' }" (click)="changeTab('home')" >
          <div class="d-flex flex-column align-items-center">

             <img [src]="activeTab === 'home' ? '../../../../assets/footer_icons/fill/Home.svg' : '../../../../assets/footer_icons/outline/Home.svg'"
                 alt="Home Icon"
                 >
            <span>{{ "home_index" | translate: "footer" }}</span>
          </div>
        </a>
      </li>
      <li class="nav-item " routerLink="/mobile/home/category" pRipple>
        <a class="nav-link" [ngClass]="{ 'active': activeTab === 'categories' }" (click)="changeTab('categories')"  >
          <div class="d-flex flex-column align-items-center">

             <img  class="nav-icon" [style.fill]="iconColor"  [src]="activeTab === 'categories' ? '../../../../assets/footer_icons/fill/category.svg' : '../../../../assets/footer_icons/outline/category.svg'"
                 alt="Categories Icon"
                 >
            <span>{{ "category_index" | translate: "footer" }}</span>
          </div>
        </a>
      </li>
      <li class="nav-item " pRipple>
        <a class="nav-link" [ngClass]="{ 'active': activeTab === 'search' }" (click)="changeTab('search');showSearchBar()"  >
          <div class="d-flex flex-column align-items-center">

             <img [src]="activeTab === 'search' ? '../../../../assets/footer_icons/fill/Search.svg' : '../../../../assets/footer_icons/outline/Search.svg'"
                 alt="Home search"
                 >
            <span>{{ "search" | translate: "footer" }}</span>
          </div>
        </a>
      </li>
      <li class="nav-item " >
        <a class="nav-link" [ngClass]="{ 'active': activeTab === 'setting' }" (click)="changeTab('setting');switchToProfile()"  >
          <div class="d-flex flex-column align-items-center">

             <img [src]="activeTab === 'setting' ? '../../../../assets/footer_icons/fill/Profile.svg' : '../../../../assets/footer_icons/outline/Profile.svg'"
                 alt="Setting Icon"
                 >
            <span>{{ "menu_index" | translate: "footer" }}</span>
          </div>
        </a>
      </li>
      <li class="nav-item " routerLink="/mobile/home/cart">
        <a class="nav-link" [ngClass]="{ 'active': activeTab === 'cart' }" (click)="changeTab('cart')"  >
          <div class="d-flex flex-column align-items-center">

             <img [src]="activeTab === 'cart' ? '../../../../assets/footer_icons/fill/Buy.svg' : '../../../../assets/footer_icons/outline/Buy.svg'"
                 alt="Cart Icon"
                 >
            <span>{{ "cart_index" | translate: "footer" }}</span>
          </div>
        </a>
      </li>
      <!-- Add more navigation items as needed with corresponding custom PNG images and titles -->
    </ul>
  </nav>
